import { updatePlayerLastSeenUpdateId } from "@dailywars/core/db";
import { createServerFn } from "@tanstack/react-start";

import { getRequestLogger, logRequestError } from "#/lib/requestLogger.server";
import { markUpdatesSeenInputSchema } from "#/lib/serverInputSchemas";
import { authedMiddleware } from "#/server/authedMiddleware";

export const markUpdatesSeen = createServerFn({ method: "POST" })
  .middleware([authedMiddleware])
  .validator(markUpdatesSeenInputSchema)
  .handler(async ({ context, data }) => {
    getRequestLogger().set({ profile: { action: "mark_updates_seen", update_id: data.updateId } });
    try {
      await updatePlayerLastSeenUpdateId({ playerId: context.userId, updateId: data.updateId });
    } catch (error) {
      logRequestError({
        log: getRequestLogger(),
        error,
        context: { profile: { step: "mark_updates_seen" } },
      });
      throw error;
    }
  });
